import { motion } from "framer-motion";

const GOLD = "#D4AF37";

const FILLED = {
  heart: "M12 21c-4.6-3.7-9-7-9-11.2C3 6.6 5.4 4.5 8 4.5c1.6 0 3.1.8 4 2.1.9-1.3 2.4-2.1 4-2.1 2.6 0 5 2.1 5 5.3 0 4.2-4.4 7.5-9 11.2z",
  sparkle: "M12 2l2.2 7.8L22 12l-7.8 2.2L12 22l-2.2-7.8L2 12l7.8-2.2L12 2z",
};

const LINE = {
  gift: (
    <>
      <path d="M18 30h28v7H18z" fill="#F3D9DC" stroke="none" />
      <rect x="18" y="30" width="28" height="22" rx="2" />
      <path d="M18 37h28" />
      <path d="M32 30v22" stroke={GOLD} />
      <path d="M32 30c-4-6-11-6-11-2.5S26.5 31 32 30z" fill="#E6C2C6" stroke={GOLD} />
      <path d="M32 30c4-6 11-6 11-2.5S37.5 31 32 30z" fill="#E6C2C6" stroke={GOLD} />
    </>
  ),
  balloon: (
    <>
      <path d="M32 12c7 0 11 5 11 11.5S39 36 32 36s-11-5.5-11-12.5S25 12 32 12z" fill="#F3D9DC" />
      <path d="M30 36h4l-2 4z" fill="#D88C9A" stroke="none" />
      <path d="M32 40c0 4-4 4-4 8s4 3.5 4 7" stroke={GOLD} />
    </>
  ),
  envelope: (
    <>
      <rect x="13" y="21" width="38" height="26" rx="2" />
      <path d="M13 23l19 13.5L51 23" />
      <path
        d="M32 40c-2-2.2-4.6-1.1-4.6.8 0 1.6 2.3 3.2 4.6 4.4 2.3-1.2 4.6-2.8 4.6-4.4 0-1.9-2.6-3-4.6-.8z"
        stroke={GOLD}
      />
    </>
  ),
  bow: (
    <>
      <path d="M32 28C26 18 12 16 8 22c-3.5 5.5 5 11 24 6z" />
      <path d="M32 28c6-10 20-12 24-6 3.5 5.5-5 11-24 6z" />
      <path d="M29 31c-5 5-11 8-17 10" stroke={GOLD} />
      <path d="M35 31c5 5 11 8 17 10" stroke={GOLD} />
      <circle cx="32" cy="28.5" r="2.4" stroke={GOLD} />
    </>
  ),
  ring: (
    <>
      <circle cx="32" cy="39" r="13" />
      <path d="M32 20l-4.5-6h9L32 20z" stroke={GOLD} />
      <path d="M27.5 14L32 8l4.5 6" stroke={GOLD} />
    </>
  ),
  mug: (
    <>
      <path d="M18 24h24v18a7 7 0 0 1-7 7H25a7 7 0 0 1-7-7V24z" />
      <path d="M42 27h4a6 6 0 0 1 0 12h-4" />
      <path
        d="M30 34c-2.4-2.7-5.8-1.4-5.8.8 0 1.9 2.9 3.9 5.8 5.4 2.9-1.5 5.8-3.5 5.8-5.4 0-2.2-3.4-3.5-5.8-.8z"
        stroke={GOLD}
      />
      <path d="M24 19c0-2.2 2-2.2 2-4.4" />
      <path d="M31 19c0-2.2 2-2.2 2-4.4" />
    </>
  ),
  hamper: (
    <>
      <path d="M14 30h36l-3.5 17a5 5 0 0 1-5 4h-19a5 5 0 0 1-5-4L14 30z" />
      <path d="M22 30c0-7 4.5-11 10-11s10 4 10 11" />
      <path d="M32 18c-3.5-4.5-9-4.5-9-1s4.5 3.5 9 1z" stroke={GOLD} />
      <path d="M32 18c3.5-4.5 9-4.5 9-1s-4.5 3.5-9 1z" stroke={GOLD} />
    </>
  ),
};

export const DecorIcon = ({ type, className }) => (
  <svg
    viewBox="0 0 64 64"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.4"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
  >
    {LINE[type]}
  </svg>
);

export const FloatItem = ({
  type,
  filled = false,
  color,
  className = "",
  delay = 0,
  duration = 9,
  drift = 16,
  sway = 8,
  spin = 8,
}) => (
  <motion.div
    className={`absolute pointer-events-none ${className}`}
    initial={{ opacity: 0, scale: 0.5, y: 24 }}
    animate={{ opacity: 1, scale: 1, y: 0 }}
    transition={{ duration: 1.2, delay, ease: [0.16, 1, 0.3, 1] }}
    aria-hidden="true"
  >
    <motion.div
      animate={{ y: [0, -drift, 0], x: [0, sway, 0], rotate: [0, spin, 0, -spin, 0] }}
      transition={{ duration, repeat: Infinity, ease: "easeInOut", delay }}
      className="w-full h-full"
    >
      {filled ? (
        <svg viewBox="0 0 24 24" className="w-full h-full" fill={color || "#D88C9A"}>
          <path d={FILLED[type]} />
        </svg>
      ) : (
        <DecorIcon type={type} className="w-full h-full" />
      )}
    </motion.div>
  </motion.div>
);

export const Twinkle = ({ className = "", delay = 0, color = GOLD }) => (
  <motion.svg
    viewBox="0 0 24 24"
    className={`absolute pointer-events-none ${className}`}
    fill={color}
    aria-hidden="true"
    animate={{
      opacity: [0.1, 1, 0.3, 1, 0.1],
      scale: [0.5, 1, 0.65, 1, 0.5],
      rotate: [0, 25, 0],
    }}
    transition={{ duration: 4, repeat: Infinity, delay, ease: "easeInOut" }}
  >
    <path d={FILLED.sparkle} />
  </motion.svg>
);
